import {FILTERS_ARGS} from "@/app/exercise/modules/trainings/core/training-const";
import {ExamFiltersDTO} from "@/models/filters/ExamFiltersDTO";

export class ExamFiltersModel {
  constructor(filters) {
    this.filters = new ExamFiltersDTO(filters)
  }

  getApiData() {
    return {
      [FILTERS_ARGS.IS_AUTO]: this.filters.is_auto,
      [FILTERS_ARGS.IS_MOTOR]: this.filters.is_motor,
      [FILTERS_ARGS.IS_SCOOTER]: this.filters.is_scooter,
      [FILTERS_ARGS.TENANT]: this.filters.tenant,
    }
  }
}
